import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the onDemandSettlements state domain
 */

const selectOnDemandSettlementsDomain = state =>
  state.onDemandSettlements || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by OnDemandSettlements
 */

const makeSelectOnDemandSettlements = () =>
  createSelector(
    selectOnDemandSettlementsDomain,
    substate => substate,
  );

export default makeSelectOnDemandSettlements;
export { selectOnDemandSettlementsDomain };
